import { IPageRoute } from "../routes";

export const getTitleFromSidebar = (
  items: IPageRoute[],
  path: string,
): string | null => {
  for (const item of items) {
    if (item.link === path) {
      return item.title;
    }

    if (item.subpages) {
      const subpageTitle = getTitleFromSidebar(item.subpages, path);
      if (subpageTitle) {
        return subpageTitle;
      }
    }
  }

  return null;
};

/** Formats a number with thousands separators */
export const formatNumberWithCommas = (
  value: number | string | null | undefined,
  options?: Intl.NumberFormatOptions,
): string => {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return String(value);
  return num.toLocaleString("en-US", options);
};

export const getDisabledActionProps = (row: any, actionConfig: any) => {
  const isDisabled =
    typeof actionConfig.isDisabled === "function"
      ? actionConfig.isDisabled(row)
      : actionConfig.isDisabled || false;

  return {
    disabled: isDisabled,
    color: isDisabled ? "#D3D3D3" : "#A39455",
    stroke: isDisabled ? "#D3D3D3" : "#A39455",
  };
};
